import React from "react";
import photo from "../../image/photo.jpg";
import "./About.css";
const About = () => {
  return (
    <div className="container mx-auto d-flex align-items-center mt-5 pos">
      <img className="aboutSection" src={photo} alt="" />
      <p className="paragraph">
        My name is Mahesh Biswas. I wanted to be a Programmer. And I wanted to
        Learn many programming language. I wanted to participate in competative
        programming contest. At present I started learning Web-development.
        After finishing it i will learn c++ after one year. Because My goal is
        not only to be a web-developer.
      </p>
    </div>
  );
};

export default About;
